// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"523":"47713d8b","689":"47713d8b","943":"c5207c2b"}[chunkId] + ".chunk.css";
};